import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import './style.scss';
import routeRegistry from '../../../../registries/RouteRegistry';

import { connect } from 'react-redux';
import browserHistory from '../../../../stores/browserHistory';

import {
  __DEV__,
  extractRelativeUrl,
  resolvePublicAssets,
} from '../../../../utils';
import { t } from '../../../../locales';
import EditBlue from '../../../../assets/images/edit-blue@3x.png';

interface EditableInputProps {
  type?: string;
  value?: string;
  label: string;
  id: string;
  onClickIcon: () => void;
  uneditable: boolean;
}

interface EditableInputState {}

class EditableInput extends Component<EditableInputProps, EditableInputState> {
  render() {
    const { uneditable, onClickIcon, label, id, type, ...rest } = this.props;

    return (
      <div className="Editable-Input change-contact-input">
        <div className="Editable-Input__label">
          <label className="emma-stylesheet-label__text" htmlFor={id}>
            {label}
          </label>
        </div>
        <div className="Editable-Input__input emma-stylesheet-input">
          {type === 'address' ? (
            <div
              className="Editable-Input__address"
              dangerouslySetInnerHTML={{
                __html: memoSanitize(this.props.value || ''),
              }}
            ></div>
          ) : (
            <input
              className="Editable-Input__input emma-stylesheet-input-field col-12"
              placeholder=""
              type="text"
              id={id}
              {...rest}
            />
          )}
          {!uneditable && (
            <img
              src={EditBlue}
              onClick={onClickIcon}
              className="Editable-Input__input-icon"
              data-enable-ga
              data-ga-type="button"
              data-ga-text={label}
            />
          )}
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    return {};
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  EditableInput.mapStateToProps,
  EditableInput.mapDispatchToProps,
)(EditableInput);
